// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "@fortawesome/fontawesome-free/js/all"
import './add_jquery'
import './add_bootstrap'
import "bootstrap-datepicker"
import "selectize"
import "chartkick/chart.js"
import "./add_sources"
import "./controllers"